// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { useAppDispatch, useAppSelector } from "app/hooks";
import Footer from "components/Footer/Footer";
import Header from "components/Header/Header";
import Benefits from "components/Home/Benefits";
import CountDown from "components/Home/CountDown";
import Hero from "components/Home/Hero";
import MyTokens from "components/Home/MyTokens";
import Success from "components/Home/Success";
import Tokens from "components/Home/Tokens";
import { getConfig, updateConfig } from "features/config/configReducer";
import { getEvent, parseStatus, selectEvent, updateEvent } from "features/event/eventReducer";
import { fetchBlockchainSupply, getPrice } from "features/stats/statsReducer";
import { checkIsConnected, getAccount, getNetwork } from "features/wallet/connect";
import { changeBalance, changeLoading, logout } from "features/wallet/walletReducer";
import { getDatabase, ref } from "firebase/database";
import React, { useEffect } from "react";
import { useList } from "react-firebase-hooks/database";
import Modal from "react-modal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { firebaseApp } from "services/firebase";

import { useEffectOnce } from "usehooks-ts";

Modal.setAppElement("#root");
const database = getDatabase(firebaseApp);

const Home: React.FC = () => {
  const [config] = useList(ref(database, "config"));
  const [event] = useList(ref(database, "event"));
  const myEvent = useAppSelector(selectEvent);
  // console.log("myEvent: ", myEvent);
  const { startTime, isStarted }:any = myEvent;
  const dispatch = useAppDispatch();

  useEffectOnce(() => {
    dispatch(getConfig());
    dispatch(getEvent());

    const fetchPrice = () => {
      dispatch(getPrice());
      setTimeout(() => {
        fetchPrice();
      }, 30000);
    };
    fetchPrice();

    const fetchBlockchain = () => {
      dispatch(fetchBlockchainSupply());
      setTimeout(() => {
        fetchBlockchain();
      }, 10000);
    };
    fetchBlockchain();

    const checkTime = () => {
      dispatch(parseStatus());
      setTimeout(() => {
        checkTime();
      }, 1000);
    };
    checkTime();

    const id = setTimeout(() => {
      dispatch(checkIsConnected());
      dispatch(changeLoading(false));
    }, 200);

    const id2 = setTimeout(() => {
      dispatch(checkIsConnected());
      dispatch(changeLoading(false));
    }, 500);

    const id3 = setTimeout(() => {
      dispatch(checkIsConnected());
      dispatch(changeLoading(false));
    }, 2000);

    return () => {
      clearTimeout(id);
      clearTimeout(id2);
      clearTimeout(id3);
    };
  });

  useEffectOnce(() => {
    const change = () => {
      setTimeout(() => {
        (window as any).fewcha.onChangeAccount(() => {
          dispatch(getAccount());
        });
        (window as any).fewcha.onChangeNetwork(() => {
          dispatch(getNetwork());
        });
        (window as any).fewcha.onDisconnect(() => {
          dispatch(logout());
        });
        (window as any).fewcha.onChangeBalance((data: any) => {
          dispatch(changeBalance(data["0x1::aptos_coin::AptosCoin"]));
        });
      }, 1000);
    };

    if (!(window as any).fewcha) {
      window.addEventListener("fewcha#initialized", change);
    } else {
      setTimeout(() => {
        window.addEventListener("fewcha#initialized", change);
      }, 2000);
    }

    return () => {
      window.removeEventListener("fewcha#initialized", change);
    };
  });

  useEffect(() => {
    if (config) {
      config.map((item) => {
        dispatch(updateConfig({ key: item.key!, value: item.val() }));
        return null;
      });
    }
  }, [dispatch, config]);

  useEffect(() => {
    if (event) {
      event.map((item) => {
        dispatch(updateEvent({ key: item.key!, value: item.val() }));
        return null;
      });
    }
  }, [dispatch, event]);

  return (
    <>
      <Header />
      <main className="z-10">
        {!isStarted && <CountDown startTime={startTime} isStarted={isStarted} />}
        <Hero isStated={isStarted} />
        <Tokens />
        <MyTokens />
        <Benefits />
        <Success />
      </main>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default Home;
